import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({
  scale,
  verticalOffset = 0,
  gradientStop1 = '#827771',
  gradientStop2 = '#CFCBC8',
}) {
  const randomGradientId1 = `_${useRandomId()}`
  const transformOrigin = '22.96 8.06'

  return (
    <g transform={`scale(${scale},${scale}) translate(0,${verticalOffset})`} transform-origin={transformOrigin}>
      <path
        d="M45.1801 2.78989C45.1801 1.09989 40.3101 0.689878 34.8501 0.649878C30.7101 0.619878 15.6101 0.639878 11.6301 0.649878C5.9501 0.659878 0.740086 1.03989 0.740086 2.78989C0.740086 5.75989 0.300074 10.5999 4.04007 12.6899C7.78007 14.7799 14.6701 15.47 17.0201 13.35C19.1901 11.39 19.8701 5.90987 22.9501 5.76987C26.0401 5.90987 26.7101 11.39 28.8801 13.35C31.2401 15.47 38.1201 14.7799 41.8601 12.6899C45.6201 10.5999 45.1801 5.75989 45.1801 2.78989Z"
        fill={`url(#${randomGradientId1})`}
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="-0.722615"
          y1="7.63891"
          x2="45.8793"
          y2="7.63891"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={gradientStop1} />
          <stop offset="0.2572" stopColor={gradientStop2} />
          <stop offset="0.8917" stopColor={gradientStop1} />
        </linearGradient>
      </defs>
    </g>
  )
}
